module.exports = __webpack_public_path__ + "img/tablet-neck-10_48x690.a218eed2.png";